/**
 * Derives a storage namespace prefix from the current URL path.
 * For example, if the app is deployed at https://example.com/app1/,
 * the prefix will be "app1". If deployed at the root, prefix will be "root".
 * This ensures two deployments on the same origin but different base paths
 * get their own isolated localStorage keys.
 */
function getBasePathPrefix(): string {
  const path = window.location.pathname;
  // Extract the first meaningful path segment as the namespace
  const segments = path.split('/').filter(Boolean);
  return segments.length > 0 ? segments[0] : 'root';
}

const STORAGE_PREFIX = getBasePathPrefix();

export function prefixKey(key: string): string {
  return `${STORAGE_PREFIX}:${key}`;
}
